import React from 'react'
import './block-timeline.sass'

const getTimelineContent = (contents) => {
  return contents.map((content, i) => {
    return (
      <li
        key={i}
        dangerouslySetInnerHTML={{ __html: content }} />
    )
  })
}

const BlockTimeline = ({ data }) => {
  return (
    <div className={`BlockTimeline ${data.classes ? data.classes : ''}`}>
      <div className="container-fluid">
        <div className="k-max-width--2 k-section text-center">
          {data.titleContent &&
            <div
              className="mb-4 mb-md-5"
              dangerouslySetInnerHTML={{ __html: data.titleContent }} />
          }
          <div className="BlockTimeline__scroll-help k-text--mono d-md-none mb-4 text-center">scroll >></div>
          <div className="BlockTimeline__timeline-wrap pt-1">
            <ol className="BlockTimeline__timeline mb-0">
              {getTimelineContent(data.content)}
            </ol>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlockTimeline
